function Footer() {
  return (
    <footer className="footer">
      <p className="disclaimer">
        This tool only help compare data shared by{" "}
        <a href="https://twitter.com/theliverdr">@theliverdr</a> in this{" "}
        <a href="https://twitter.com/theliverdr/status/1629670100595888128">
          tweet
        </a>{" "}
        based on a public health service of analysis of commercially available
        protein brands funded by{" "}
        <a href="https://twitter.com/paraschopra">@paraschopra</a> performed by{" "}
        <a href="http://www.neogenlabs.com/">Neogen Labs (P) Ltd</a>. <br></br>
        It should not be misconstrued for health advice and requires validation
        from other independent labs. No guarantees are provided on any data or
        calculations accuracy.
      </p>
    </footer>
  );
}

export default Footer;
